import { Component, Input, OnInit, OnDestroy, input } from '@angular/core';
import * as ElementModels from '../../../models/report-view.models';
import { Chart } from 'angular-highcharts';
import { ChartService } from '../../chart/chart.service';
import { BehaviorSubject, map, of, takeWhile } from 'rxjs';
import { SeriesOptionsType } from 'highcharts';
import { ElementBaseComponent } from '../ElementBaseComponent';
import { HelpTextService } from '../../../services/services-index';

@Component({
    selector: 'scorecard-billboard-element-repeater',
    templateUrl: './scorecard-billboard-element-repeater.component.html',
    styleUrls: ['../panel-elements.scss', './scorecard-billboard-element-repeater.component.scss']
})
export class ScorecardBillboardElementRepeaterComponent extends ElementBaseComponent implements OnInit {
    @Input() settings: ElementModels.ElementSettings;
    @Input() locale: string;
    @Input() set dataSets(value: ElementModels.DataSet[]) {
        if (!!value && value.length > 0) {
            this.processData(value);
            this.isDataSetLoaded$.next(true);
        } else {
            this.isDataSetLoaded$.next(false);
        }
    }

    title: string;
    titleIconClasses: string;

    dataSetsSubject = new BehaviorSubject<ElementModels.DataSet[]>([]);
    dataSets$ = this.dataSetsSubject.asObservable();

    items: { entityName: string, settings: ElementModels.ElementSettings }[] = [];

    constructor(helpTextService: HelpTextService) {
        super(helpTextService);
    }

    ngOnInit(): void {
        this.title = this.settings.title;
        this.titleIconClasses = this.settings.titleIconClasses;
    }

    private processData(dataSets: ElementModels.DataSet[]) {
      // for reach row in the first dataset of the dataSets array, we want to render a scorecard-billboard-repeater component
      // to do this, we need to create an array of objects to drive the repeater view but we'll be passing all the datasets from this component through as each of the child components know how to handle their own data
      // the key is that we create a settings dictionary for the each child component that we are able to set the 'entityName' property for based on the configured dim column of the first dataset here
      this.items = [];
      const mainDataSet = dataSets[0];
      const dimColumnIndex = mainDataSet.columns.findIndex(c => c.name === this.settings.dimensionNames[0]);

      if (dimColumnIndex === -1) {
        console.error('Dimension column not found in dataset');
        return;
      }

      //enumerate rows of the mainDataSet
      for (let i = 0; i < mainDataSet.rows.length; i++) {
        const row = mainDataSet.rows[i];
        const entityName = row[dimColumnIndex].value.toString();

        // create a new settings object for each row
        const settings = { ...this.settings, options: { ...{}, ...this.settings.options } };
        settings.options["entityName"] = entityName;

        // push the new object to the items array
        this.items.push({ entityName, settings });
      }

      console.log('items', this.items);
      this.dataSetsSubject.next(dataSets);
    }
}
